import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import CheckboxMUI from '@mui/material/Checkbox';
import cx from 'classnames';
import InputLabel from '@mui/material/InputLabel';
import styles from '@/common/components/Inputs/Checkbox/styles.less';

const Checkbox = ({ tip, label, name, withForm = true, sx, ...props }) => {
  const { control } = useFormContext() || {};

  return withForm ? (
    <Controller
      defaultValue={false}
      name={name}
      control={control}
      render={({ field: { onChange, value, name }, fieldState: { error } }) => {
        return (
          <Box className={styles.container} sx={sx}>
            <div className={styles.inputContainer}>
              <CheckboxMUI
                onChange={onChange}
                checked={value}
                name={name}
                {...props.inputProps}
              />
              <InputLabel
                className={cx(styles.label, error && styles['label-error'])}
                htmlFor={name}
              >
                {label}
              </InputLabel>
            </div>
            <InputLabel
              className={cx(
                styles.bottomLabel,
                !!error && styles['bottomLabel-error']
              )}
              htmlFor={name}
            >
              {error?.message || tip}
            </InputLabel>
          </Box>
        );
      }}
    />
  ) : (
    <Box className={styles.container} sx={sx}>
      <div className={styles.inputContainer}>
        <CheckboxMUI {...props} name={name} />
        <InputLabel
          className={cx(styles.label, props.error && styles['label-error'])}
          htmlFor={name}
        >
          {label}
        </InputLabel>
      </div>
      <InputLabel
        className={cx(
          styles.bottomLabel,
          !!props.error && styles['bottomLabel-error']
        )}
        htmlFor={name}
      >
        {props.error?.message || tip}
      </InputLabel>
    </Box>
  );
};

export default Checkbox;
